import React, { useEffect } from "react";
import Hero from "../components/home/hero";
import Second from "../components/home/second";
import AIVisitorPopup from "../components/AIVisitorPopup";
import { initScrollReveal } from "../helpers/scrollReveal";


const Home = () => {
    useEffect(() => {
        const cleanup = initScrollReveal();
        return cleanup;
    }, []);

    return(
    <>
        <Hero />
        
        <Second />
        <AIVisitorPopup />
    </>
    )
}
export default Home;